import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LoginModal } from './LoginModal';
import { migrateGuestDataToUser } from '../../utils/guestDataMigration';
import { userAuth } from '../../services/userAuth';
import './LoginPage.css';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = (location.state as { returnTo?: string })?.returnTo || '/dashboard';

  React.useEffect(() => {
    localStorage.setItem('authReturnTo', returnTo);
  }, [returnTo]);

  const handleSuccess = async (user: { id: string }) => {
    await migrateGuestDataToUser(user.id);
    userAuth.refreshUser();
    navigate(returnTo, { replace: true });
  };

  return (
    <div className="login-page-container">
      <button
        type="button"
        className="login-page-back"
        onClick={() => navigate(-1)}
      >
        ←
      </button>
      <div className="login-page-card">
        <LoginModal
          isOpen={true}
          fullPage
          returnTo={returnTo}
          onClose={() => navigate(returnTo)}
          onSuccess={handleSuccess}
          onSwitchToSignup={() => navigate('/signup', { state: { returnTo } })}
        />
      </div>
    </div>
  );
};
